import { Fragment } from "react";
import Grid from "@mui/material/Grid";

import {
  BenefitBox,
  BenefitDivider,
  CardHeader,
  PlanCard,
} from "../styles/ProductStyles";
import { ProductFeatureCard } from "./ProductFeatureCard";
import type { ProductFeature } from "../types/productTypes";

type ProductFeatureSectionProps = {
  title: string;
  color?: string;
  groups: ProductFeature[][];
};

export const ProductFeatureSection = ({
  title,
  color,
  groups,
}: ProductFeatureSectionProps) => {
  return (
    <PlanCard>
      <CardHeader $backgroundColor={color}>{title}</CardHeader>

      {groups.map((group, groupIndex) => (
        <Fragment key={`${title}_${groupIndex}`}>
          <BenefitBox>
            <Grid
              container
              spacing={2}
              columns={{
                xs: 12,
                sm: group.length,
              }}
            >
              {group.map((benefit) => (
                <Grid
                  size={{ xs: 12, sm: 1 }}
                  key={`benefit_${benefit.title}_${benefit.text ?? ""}`}
                >
                  <ProductFeatureCard benefit={benefit} />
                </Grid>
              ))}
            </Grid>
          </BenefitBox>

          <BenefitDivider />
        </Fragment>
      ))}
    </PlanCard>
  );
};